// extracted by mini-css-extract-plugin
export default {"dragging":"HIsA4"};